/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
class SplitOrder {

    constructor() {
        this.splitOrderButtonSelector = '#split_order';
        this.splitOrderFormSelector = '#split_order_form';
        this.cancelSplitOrderButtonSelector = '#cancel_split_order';
        this.cancelSplitOrderFormSelector = '#cancel_split_order_form';
    }

    getData(form) {
        return $(form).serialize();
    }

    splitOrder() {
        let self = this;

        $.ajax({
            url: '/shop/orders/split',
            type: 'POST',
            data: self.getData(this.splitOrderFormSelector),
            success: function (response) {
                self.showSuccessMessage(response.data.message);
                if(response.data.status_success){
                    window.location.reload();
                }
            }
        });
    }

    cancelSplitOrder() {
        let self = this;

        $.ajax({
            url: '/shop/orders/cancel_split',
            type: 'POST',
            data: self.getData(this.cancelSplitOrderFormSelector),
            success: function (response) {
                self.showSuccessMessage(response.data.message);
                if(response.data.status_success){
                    window.location.reload();
                }
            }
        });
    }

    showSuccessMessage(message) {
        alert(message);
    }

    init() {
        this.listenSplitOrder();
        this.listenCancelSplitOrder();
    }

    listenSplitOrder() {
        $(document).on('click', this.splitOrderButtonSelector, (event) => {
            event.stopPropagation();

            if(confirm("Вы действительно хотите разделить заказ?")) {
                this.splitOrder();
            }

            return false;
        });
    }

    listenCancelSplitOrder() {
        $(document).on('click', this.cancelSplitOrderButtonSelector, (event) => {
            event.stopPropagation();

            if(confirm("Вы действительно хотите отменить разделение заказа?")) {
                this.cancelSplitOrder();
            }

            return false;
        });
    }

}

module.exports = SplitOrder;